module.exports = __webpack_public_path__ + "img/banlac.9682b35b.png";